import React from 'react'

const CloseCross = ({ w = 12, h = w }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0,0,80,80"
			width={`${w}px`}
			height={`${h}px`}
		>
			<line
				x1="-38.9553"
				y1="3.43204e-06"
				x2="31.0446"
				y2="-70"
				strokeWidth="9.89948866396827"
				stroke="currentColor"
				transform="matrix(1 0 0 1 44.4294 75.4853)"
			></line>
			<line
				x1="-39.42937469482422"
				y1="-0.48533989815041423"
				x2="30.570581436157227"
				y2="69.51461410522461"
				strokeWidth="9.89948866396827"
				stroke="currentColor"
				transform="matrix(1 0 0 1 44.4294 5.48536)"
			></line>
		</svg>
	)
}

export default CloseCross
